<template>
  <!-- start 头部 -->
  <div class="header-vessel">
    <img class="header-vessel-icon" src="@/assets/images/bg1.png" />
    <img class="header-icon-left" src="@/assets/images/bg3.png">
    <img class="header-icon-right" src="@/assets/images/bg2.png">

    <div class="header-vessel-content"></div>
    <!-- onmousedown="mouseDown()" -->
    <div
      class="header-vessel-top"
      @mousedown="mousedown"
      @mousemove="mousemove"
      @mouseup="mouseup"
      @mouseleave="mousemove"
    >
      <div class="header-vessel-content-top">
        <div class="software-info">
          <img
            class="software-info-img"
            src="@/assets/images/product-icon.png"
          />
          <!-- <span class="software-info-title">全能王打字练习</span> -->
        </div>
        <div class="operation-info">
          <div
            class="wx-login-operation"
            v-if="isWxLogin"
            @click.stop="isShowWxUserInfo = !isShowWxUserInfo"
          >
            <div class="head-portrait">
              <img class="head-portrait-icon" :src="wxUserInfo.avatar" />
              <img
                v-if="!isVip"
                class="head-portrait-vip"
                src="@/assets/images/not-vip-icon.png"
              />
              <img
                v-if="isVip"
                class="head-portrait-vip"
                src="@/assets/images/is-vip-icon.png"
              />
            </div>
            <div class="wx-nickname">{{ wxUserInfo.nickname }}</div>
            <div class="wx-user-info" v-if="isShowWxUserInfo" @click.stop="">
              <div class="wx-user-info-header">
                <img
                  class="wx-user-info-header-icon"
                  :src="wxUserInfo.avatar"
                />
                <div class="wx-user-infos">
                  <div class="wx-user-infos-title">
                    昵称：{{ wxUserInfo.nickname }}
                    <img
                      v-if="!isVip"
                      class="wx-user-infos-vip"
                      src="@/assets/images/not-vip-icon.png"
                    />
                    <img
                      v-if="isVip"
                      class="wx-user-infos-vip"
                      src="@/assets/images/is-vip-icon.png"
                    />
                  </div>
                  <div class="wx-user-infos-title">
                    (ID：{{ wxUserInfo.uid }})
                  </div>
                  <div class="not-vip" v-if="!isVip">
                    <span class="not-vip-title">开通会员享受更多特权</span>
                    <div class="open-vip" @click="openFun">开通会员</div>
                  </div>
                  <div class="not-vip" v-if="isVip">
                    会员到期：{{ expiryTime }}
                  </div>
                </div>
              </div>
              <div class="wx-user-info-content">
                <div class="vip-info">
                  <div class="vip-info-header">
                    <div class="separator"></div>
                    <div class="vip-info-header-title">会员尊贵特权</div>
                    <div class="separator"></div>
                  </div>
                  <div class="vip-info-body">
                    <div class="vip-info-list margin-right">
                      <img src="@/assets/images/dz-game-icon.png" />
                      <div class="vip-info-list-title">打字游戏</div>
                    </div>
                    <div class="vip-info-list margin-right">
                      <img src="@/assets/images/practice-course-icon.png" />
                      <div class="vip-info-list-title">练习课程</div>
                    </div>
                    <div class="vip-info-list margin-right">
                      <img src="@/assets/images/data-statistics-icon.png" />
                      <div class="vip-info-list-title">数据统计</div>
                    </div>
                    <div class="vip-info-list">
                      <img src="@/assets/images/course-icon.png" />
                      <div class="vip-info-list-title">更多课程</div>
                    </div>
                  </div>
                  <div class="separators"></div>
                  <div class="quit-wx-login" @click="WithdrawAccount">
                    退出账号
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="operation-info-login"
            v-if="!isWxLogin"
            @click="showWxLogin"
          >
            <img
              class="operation-info-login-icon"
              src="@/assets/images/default-user-iocn.png"
            />
            <span class="operation-info-login-title">登录/注册</span>
          </div>
          <!-- <div
            class="operation-info-user"
            v-if="isLogin"
            @click.stop="loginOpen = true"
          >
            <img
              class="operation-info-user-left"
              src="@/assets/images/login-user-icon.png"
            />
            <div class="operation-info-user-info">
              {{ userInfoForm.nickname }}
            </div>
            <img
              class="operation-info-user-icon"
              src="@/assets/images/xia-icon.png"
            />
          </div> -->
          <div class="operation-info-reduce">
            <img
              class="operation-icon"
              @mouseenter="minimizeStatus = 1"
              v-if="minimizeStatus == 0"
              @click.stop="minimizeWindows()"
              src="@/assets/images/default-minimize-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="minimizeStatus = 0"
              v-if="minimizeStatus == 1"
              @click.stop="minimizeWindows()"
              src="@/assets/images/immigration-minimize-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="minimizeStatus = 0"
              v-if="minimizeStatus == 2"
              @click.stop="minimizeWindows()"
              src="@/assets/images/click-minimize-icon.png"
            />
          </div>
          <div class="operation-info-window">
            <!-- start 扩大窗口 -->
            <img
              class="operation-icon"
              @mouseenter="bigWindow = 1"
              v-if="zoomState == 0 && bigWindow == 0"
              @click.stop="bigWindowFun()"
              src="@/assets/images/default-bigWindow-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="bigWindow = 0"
              v-if="zoomState == 0 && bigWindow == 1"
              @click.stop="bigWindowFun()"
              src="@/assets/images/immigration-bigWindow-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="bigWindow = 0"
              v-if="zoomState == 0 && bigWindow == 2"
              @click.stop="bigWindowFun()"
              src="@/assets/images/click-bigWindow-icon.png"
            />
            <!-- end 扩大窗口 -->
            <img
              class="operation-icon"
              @mouseenter="inWindow = 1"
              v-if="zoomState == 1 && inWindow == 0"
              @click.stop="inWindowFun()"
              src="@/assets/images/default-inWindow-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="inWindow = 0"
              v-if="zoomState == 1 && inWindow == 1"
              @click.stop="inWindowFun()"
              src="@/assets/images/immigration-inWindow-icon.png"
            />
            <img
              class="operation-icon"
              @mouseleave="inWindow = 0"
              v-if="zoomState == 1 && inWindow == 2"
              @click.stop="inWindowFun()"
              src="@/assets/images/click-inWindow-icon.png"
            />
          </div>
          <div class="operation-info-close">
            <img
              @mouseenter="closeStatus = 1"
              v-if="closeStatus == 0"
              @click.stop="closeWindows()"
              class="operation-icon"
              src="@/assets/images/default-close-icon.png"
            />
            <img
              @mouseleave="closeStatus = 0"
              v-if="closeStatus == 1"
              @click.stop="closeWindows()"
              class="operation-icon"
              src="@/assets/images/immigration-close-icon.png"
            />
            <img
              @mouseleave="closeStatus = 0"
              v-if="closeStatus == 2"
              @click.stop="closeWindows()"
              class="operation-icon"
              src="@/assets/images/click-close-icon.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="header-vessel-bottom">
      <slot name="bottom"></slot>
    </div>
    <!-- start 登录插件 -->
    <!-- <LoginPopupVue
      :open="open"
      @close="(open = false), onloadUser()"
    ></LoginPopupVue> -->
    <!-- end 登录插件 -->
    <MembersBuy
      :open="openVipSign"
      @close="openVipSign = false"
      @reloadVipInfo="isWhether('reload')"
    ></MembersBuy>
    <!-- <LoginPopupVue
      :open="loginOpen"
      @close="loginOpen = false"
      @onloadUser="delayOnloadUser"
    ></LoginPopupVue> -->
  </div>
  <!-- end 头部 -->
</template>

<script>
// import LoginPopupVue from "@/components/LoginPopup.vue";
import MembersBuy from "@/components/MembersBuy.vue";
import { instance } from "../useModules/instance";
import {
  isTiming,
  startTrialTimer,
  stopTrialTimer,
} from "../useModules/useTrial/use";
import { needStartTrialList } from "@/router/index";
export default {
  name: "CustomHead",
  components: {
    // LoginPopupVue,
    MembersBuy,
  },
  data() {
    return {
      // 登录open
      // loginOpen: false,
      // 是否打开
      // open: false,
      // 缩小状态
      minimizeStatus: 0,
      // 关闭状态
      closeStatus: 0,
      // 用户信息
      userInfoForm: {},
      // 是否登录
      isLogin: false,
      // 是否微信登录
      isWxLogin: false,
      // 展开微信用户信息
      isShowWxUserInfo: false,
      // 放大状态
      // zoomState: 0,
      // 大窗口
      bigWindow: 0,
      // 缩小
      inWindow: 0,
      //
      isVip: false,
      // 微信用户信息
      wxUserInfo: {},
      // 过期时间
      expiryTime: "",
      openVipSign: false,
      x: 0, //left:x
      y: 0, //top:y
      leftOffset: 0, //鼠标距离移动窗口左侧偏移量
      topOffset: 0, //鼠标距离移动窗口顶部偏移量
      isMove: false, //是否移动标识
    };
  },
  watch: {
    openVipSign: {
      handler(val) {
        if (val) {
          stopTrialTimer();
        } else {
          startTrialTimer({
            minTime: 10,
            path: this.$route.path,
          });
        }
      },
    },
  },
  computed: {
    //top与left加上px
    position() {
      return `top:${this.y}%;left:${this.x}%;`;
    },
    zoomState() {
      return this.$store.state.zoomState;
    },
  },
  mounted() {
    document.body.addEventListener(
      "click",
      () => {
        this.isShowWxUserInfo = false;
      },
      false
    );
  },
  created() {
    // 加载用户信息
    this.onloadUser();
    // 加载微信用户信息
    this.onloadWxUser();
    // 获取软件是否过期
    this.isWhether();
    // 加载单词意思；
    let wordMeaning = localStorage.getItem("wordMeaning");
    if (!wordMeaning) {
      this.loadMeaningWord();
    }
  },
  methods: {
    showWxLogin() {
      console.log("触发微信登录");
      instance.$emit("showWxLogin");
    },
    mousedown(event) {
      this.leftOffset = event.offsetX;
      this.topOffset = event.offsetY;
      this.isMove = true;
    },
    mousemove(event) {
      if (!this.isMove) {
        return;
      }
      this.x = event.clientX - this.leftOffset;
      this.y = event.clientY - this.topOffset;
    },
    mouseup() {
      this.isMove = false;
    },
    mouseDown() {
      window.eMsg("move");
    },
    // 拖拽
    drag() {
      window.eMsg("move");
    },
    // 加载单词意思
    loadMeaningWord() {
      this.$http({
        url: "/static/course/en/config/en.xml",
        method: "get",
      }).then(({ data }) => {
        let json = this.$x2js.xml2js(data);
        if (
          json.word != undefined &&
          json.word.pair != undefined &&
          Array.isArray(json.word.pair)
        ) {
          localStorage.setItem("wordMeaning", JSON.stringify(json.word.pair));
        }
      });
    },
    // 最小化
    minimizeWindows() {
      this.minimizeStatus = 2;
      window.win_minimized();
    },
    // 关闭弹窗
    closeWindows() {
      this.closeStatus = 2;
      window.win_close();
    },
    // 扩大窗口
    bigWindowFun() {
      this.$store.commit("setZoomState", 1);
      window.win_maximized();
    },
    // 恢复窗口
    inWindowFun() {
      this.$store.commit("setZoomState", 0);
      window.win_maximized();
    },
    // 退出账号
    WithdrawAccount() {
      localStorage.setItem("wxUserInfo", "");
      localStorage.setItem("token", ""); //
      this.isShowWxUserInfo = false;
      this.wxUserInfo = null;
      this.isWxLogin = false;
      this.$emit("withdrawAccount", this.isVip);
      this.$router.push("/");
    },
    // 开通Vip
    openFun() {
      // this.openVipSign = true;
      instance.$emit("showMembersBuy");
      this.isShowWxUserInfo = false;
    },
    // 记载登录用户数据
    onloadUser() {
      let loginUser = localStorage.getItem("loginData");
      if (loginUser) {
        this.userInfoForm = JSON.parse(loginUser);
        this.isLogin = true;
        this.$emit("getUserInfo", this.userInfoForm);
      }
    },
    // 延迟
    delayOnloadUser() {
      setTimeout(() => {
        this.onloadUser();
      }, 200);
    },
    // 微信用户信息
    onloadWxUser() {
      let wxUserInfo = localStorage.getItem("wxUserInfo");
      if (wxUserInfo) {
        this.wxUserInfo = JSON.parse(wxUserInfo);
        this.isWxLogin = true;
        this.$emit("wxLoginOk", this.wxUserInfo);
      }
    },
    // 是否vip
    isWhether(type) {
      let token = localStorage.getItem("token");
      if (token) {
        let data = {
          token: token,
        };
        this.$http({
          url: "https://api.kuaixunda.cn/api/license",
          method: "get",
          params: data,
        }).then(({ data }) => {
          if (data.code == 0) {
            if (data.data.status == 1) {
              this.$store.commit("setIsVip", true);
              this.isVip = true;
              this.$emit("isVip");
              this.expiryTime = data.data.expiry;
            } else {
              this.isVip = false;
              if (type === "reload") {
                startTrialTimer({
                  minTime: 10,
                  path: this.$route.path,
                });
              }
              // if (
              //   type === "reload" &&
              //   !isTiming.value &&
              //   needStartTrialList.findIndex((item) =>
              //     this.$route.path.includes(item)
              //   ) !== -1
              // ) {
              //   this.$router.push({ name: "Home" }).catch(() => {});
              // }
            }
          }
          if (data.code == 403) {
            this.WithdrawAccount();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-vessel {
  width: 100%;
  height: 166px;
  position: relative;
  .header-vessel-icon {
    width: 100%;
    height: 100%;
  }

  .header-icon-left {
    position: absolute;
    left: 60px;
    bottom: 10px;
    width: 163px;
    height: 111px;
  }
  .header-icon-right {
    position: absolute;
    right: 162px;
    top: 10px;
    width: 200px;
    height: 143px;
  }

  .header-vessel-top {
    -webkit-app-region: drag;
    width: 100%;
    height: 102px;
    position: absolute;
    top: 0;
    left: 0;
    .header-vessel-content-top {
      display: flex;
      justify-content: space-between;
      padding: 10px 12px;
      box-sizing: border-box;
      .software-info {
        display: flex;
        align-items: center;
        margin-left: 20px;
        .software-info-img {
          height: 90px;
        }
        .software-info-title {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .operation-info {
      -webkit-app-region: no-drag;
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      .wx-login-operation {
        margin-right: 18px;
        display: flex;
        align-items: center;
        position: relative;
        .head-portrait {
          width: 28px;
          height: 28px;
          position: relative;
          .head-portrait-icon {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .head-portrait-vip {
            position: absolute;
            top: 16px;
            left: 19px;
            width: 16px;
            height: 14px;
          }
        }
        .wx-nickname {
          margin-left: 12px;
          width: 60px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 400;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //用省略号显示
          white-space: nowrap; //不换行
        }
        .wx-user-info {
          position: absolute;
          left: -161px;
          top: 30px;
          width: 322px;
          height: 257px;
          background: #ffffff;
          border: 1px solid #e1e1e1;
          z-index: 996;
          .wx-user-info-content {
            cursor: default;
            display: flex;
            justify-content: center;
            .vip-info {
              margin-top: 10px;
              .vip-info-header {
                display: flex;
                align-items: center;
                .vip-info-header-title {
                  margin: 0 10px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #000000;
                }
                .separator {
                  width: 80px;
                  height: 1px;
                  background: #e1e1e1;
                }
              }
              .quit-wx-login {
                margin-top: 10px;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                text-align: center;
                cursor: pointer;

              }
              .vip-info-body {
                margin-top: 12px;
                display: flex;
                .margin-right {
                  margin-right: 25px;
                }
                .vip-info-list {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  img {
                    width: 35px;
                    height: 35px;
                  }
                  .vip-info-list-title {
                    margin-top: 6px;
                    color: #585858;
                    font-size: 12px;
                    font-weight: 400;
                  }
                }
              }
              .separators {
                margin-top: 20px;
                width: 268px;
                height: 1px;
                background: #e1e1e1;
              }
            }
          }
          .wx-user-info-header {
            width: 100%;
            height: 96px;
            background: linear-gradient(270deg, #3251ce 0%, #6a63e5 100%);
            border-radius: 3px 3px 0px 0px;
            opacity: 1;
            padding-top: 14px;
            padding-left: 12px;
            box-sizing: border-box;
            display: flex;
            .wx-user-info-header-icon {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-left: 12px;
            }
            .wx-user-infos {
              flex: 1;
              margin-left: 14px;
              .wx-user-infos-title {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 4px;
                display: flex;
                align-items: center;
                .wx-user-infos-vip {
                  margin-left: 10px;
                  width: 16px;
                  height: 14px;
                }
              }
              .not-vip {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                .not-vip-title {
                  font-size: 12px;
                  font-weight: 400;
                  color: #ffffff;
                }
                .open-vip {
                  width: 100px;
                  height: 28px;
                  background: #ffffff;
                  border-radius: 14px 14px 14px 14px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #3a53d2;
                  text-align: center;
                  line-height: 28px;
                  margin-right: 14px;
                }
              }
            }
          }
        }
      }
      .operation-info-user {
        width: 94px;
        height: 20px;
        background: linear-gradient(180deg, #e7f1fb 0%, #adcef1 100%);
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #858585;
        display: flex;
        align-items: center;
        padding: 0 6px;
        box-sizing: border-box;
        cursor: pointer;
        .operation-info-user-left {
          width: 10px;
          height: 10px;
        }
        .operation-info-user-info {
          flex: 1;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #526070;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //用省略号显示
          white-space: nowrap; //不换行
        }
        .operation-info-user-icon {
          width: 7px;
          height: 4px;
        }
      }
      .operation-info-login {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 28px;
        .operation-info-login-icon {
          width: 16px;
          height: 16px;
        }
        .operation-info-login-title {
          margin-left: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #fefefe;
        }
      }
      .operation-icon {
        width: 40px;
        height: 28px;
      }
      .operation-info-reduce {
        margin-left: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .operation-info-window {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .operation-info-close {
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
  .header-vessel-content {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    .header-vessel-content-top {
      display: flex;
      justify-content: space-between;
      padding: 10px 12px;
      box-sizing: border-box;
      .software-info {
        display: flex;
        align-items: center;
        .software-info-img {
          width: 20px;
          height: 20px;
        }
        .software-info-title {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .operation-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      .wx-login-operation {
        margin-right: 18px;
        display: flex;
        align-items: center;
        position: relative;
        .head-portrait {
          width: 28px;
          height: 28px;
          position: relative;
          .head-portrait-icon {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .head-portrait-vip {
            position: absolute;
            top: 16px;
            left: 19px;
            width: 16px;
            height: 14px;
          }
        }
        .wx-nickname {
          margin-left: 12px;
          width: 60px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 400;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //用省略号显示
          white-space: nowrap; //不换行
        }
        .wx-user-info {
          position: absolute;
          left: -161px;
          top: 30px;
          width: 322px;
          height: 257px;
          background: #ffffff;
          border: 1px solid #e1e1e1;
          z-index: 996;
          .wx-user-info-content {
            display: flex;
            justify-content: center;
            .vip-info {
              margin-top: 10px;
              .vip-info-header {
                display: flex;
                align-items: center;
                .vip-info-header-title {
                  margin: 0 10px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #000000;
                }
                .separator {
                  width: 80px;
                  height: 1px;
                  background: #e1e1e1;
                }
              }
              .quit-wx-login {
                margin-top: 10px;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                text-align: center;
              }
              .vip-info-body {
                margin-top: 12px;
                display: flex;
                .margin-right {
                  margin-right: 25px;
                }
                .vip-info-list {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  img {
                    width: 35px;
                    height: 35px;
                  }
                  .vip-info-list-title {
                    margin-top: 6px;
                    color: #585858;
                    font-size: 12px;
                    font-weight: 400;
                  }
                }
              }
              .separators {
                margin-top: 20px;
                width: 268px;
                height: 1px;
                background: #e1e1e1;
              }
            }
          }
          .wx-user-info-header {
            width: 100%;
            height: 96px;
            background: linear-gradient(270deg, #3251ce 0%, #6a63e5 100%);
            border-radius: 3px 3px 0px 0px;
            opacity: 1;
            padding-top: 14px;
            padding-left: 12px;
            box-sizing: border-box;
            display: flex;
            .wx-user-info-header-icon {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-left: 12px;
            }
            .wx-user-infos {
              flex: 1;
              margin-left: 14px;
              .wx-user-infos-title {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 4px;
                display: flex;
                align-items: center;
                .wx-user-infos-vip {
                  margin-left: 10px;
                  width: 16px;
                  height: 14px;
                }
              }
              .not-vip {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                .not-vip-title {
                  font-size: 12px;
                  font-weight: 400;
                  color: #ffffff;
                }
                .open-vip {
                  width: 100px;
                  height: 28px;
                  background: #ffffff;
                  border-radius: 14px 14px 14px 14px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #3a53d2;
                  text-align: center;
                  line-height: 28px;
                  margin-right: 14px;
                }
              }
            }
          }
        }
      }
      .operation-info-user {
        width: 94px;
        height: 20px;
        background: linear-gradient(180deg, #e7f1fb 0%, #adcef1 100%);
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #858585;
        display: flex;
        align-items: center;
        padding: 0 6px;
        box-sizing: border-box;
        cursor: pointer;
        .operation-info-user-left {
          width: 10px;
          height: 10px;
        }
        .operation-info-user-info {
          flex: 1;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #526070;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //用省略号显示
          white-space: nowrap; //不换行
        }
        .operation-info-user-icon {
          width: 7px;
          height: 4px;
        }
      }
      .operation-info-login {
        display: flex;
        align-items: center;
        cursor: pointer;
        .operation-info-login-icon {
          width: 16px;
          height: 16px;
        }
        .operation-info-login-title {
          margin-left: 5px;
          font-size: 12px;
          font-weight: 400;
          color: #fefefe;
        }
      }
      .operation-icon {
        width: 40px;
        height: 28px;
      }
      .operation-info-reduce {
        margin-left: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .operation-info-window {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .operation-info-close {
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
  .header-vessel-bottom {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 64px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.4) 0%,
      #ffffff 100%
    );
    filter: blur(undefinedpx);
  }
}
</style>

